import type { FaireProductEntity } from "../../entity_types/product";

export const p_kaspsnemwu: FaireProductEntity = {
  token: "p_kaspsnemwu",
  type: "product",
  name: "Hummingbird Sticker",
  brandToken: "b_6i5zv0objg",
  brandName: "Bird Collective",
  imageUrl:
    "https://cdn.faire.com/fastly/db7a2b925ba926c24a3826571aec8e98bb6f8007cb360e0b97590647fdefabde.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.5,
  description:
    "Three bold hummingbirds hover among bright red blooms in this vibrant die-cut sticker. With rich navy linework, warm golden tones, and a soft pink backdrop, it captures the fast, fearless energy of these tiny pollinators. Perfect for water bottles, laptops, and field notebooks.\n",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:46.002Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
